import Vue from 'vue'
import Vuex from 'vuex'
import Vuetify from 'vuetify'
import App from './App'
import store from './store'
import router from './router'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueChatScroll from 'vue-chat-scroll'
import Autocomplete from 'v-autocomplete'
import VueSweetalert2 from 'vue-sweetalert2'
import WebRTC from 'vue-webrtc'
import 'hchs-vue-charts'
import 'chart.js'
import '@/services/Api.interceptor.js'
import './plugins'
import './styles/css/app.css'
// import './styles/scss/core.scss'

/* styles */
import 'v-autocomplete/dist/v-autocomplete.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import moment from 'moment';
// import VueSocketIO from 'vue-socket.io'

/* Vue.use(new VueSocketIO({
  debug: true,
  connection: 'http://192.168.1.12:8081'
})) */
Vue.use(WebRTC)
Vue.use(Autocomplete)
Vue.use(VueChatScroll)
Vue.use(vueVimeoPlayer)
Vue.use(window.VueCharts)
Vue.use(Vuex)
Vue.use(VueSweetalert2)
Vue.use(Vuetify, {
  theme: {
    primary: '#e65100',
    secondary: '#f57c00',
    accent: '#00897b',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false
moment.locale('es-mx');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js